import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DateRange, StatsType } from '../declarations';

export interface VehicleStatistics {
    visitorsContacts: Array<{ date: string, visitorCount: number, contactsCount: number }>;
    contactMethodsData: Array<{ date: string, phoneCount: number, emailCount: number, vfsCount: number }>;
    visitorLocationsData: Array<{ location: string, count: number }>;
}

@Injectable({
    providedIn: 'root'
})
export class InternalDetailsChartCardService {
    private apiBaseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getVehicleStatistics(vehicleId: string, statsType: StatsType, dateRange: DateRange): Observable<VehicleStatistics> {
        const endpoint = `${this.apiBaseUrl}InternalData/internal-truck-statistics/${statsType}/${vehicleId}`;
        return this.http.get<VehicleStatistics>(endpoint, {
            params: { dateRange }
        }).pipe(
            catchError(error => {
                console.error('Error fetching vehicle statistics:', error);
                // For development - provide mock data if API is not available
                throw error;
            })
        );
    }
}